/**
 * Users
 */

// React
import React, { FunctionComponent, useContext, useEffect, useState } from 'react';

// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getProductsAction,
  updateProductActions,
  createProductsActions,
  getAllProductsAction, getVitrinProductsAction,
} from './actions';
import { getPartnerCategoriesActions } from '../partners/actions';
import { Store } from '../../redux/reducers';
import { getParcelInventoryItemsAction } from '../parcels/actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectList,
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectAllList,
  makeSelectAllListLoading, makeSelectVitrinList, makeSelectVitrinCount,
} from './selectors';
import { makeSelectLoading as makeCategoriesLoding } from '../partners/selectors';
import { makeSelectSkusInventoryList } from '../warehouses/selectors';
import { getSkusInventoryActions } from '../warehouses/actions';

// Components
import Pagination from '@material-ui/lab/Pagination';
import List from './components/list';
import Edit from './components/edit';
import Add from './components/add';
import Inventory from './components/inventory';
import Modal from '../../components/Modal';
import ReportList from '../warehouseInventory/components/reportList';
import ProductsMob from './mobileView';
import windowSize from '../../utils/hook/useWindowResize';

// UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  DialogTitle,
  FormControl,
  Select,
  MenuItem,
  Box,
  Card,
  CardHeader,
  CardContent,
  Paper,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiArrowRight,
  mdiKeyOutline,
  mdiFormatListBulleted,
  mdiArchiveOutline,
  mdiPlusBoxOutline,
  mdiChatOutline,
} from '@mdi/js';

// Helper
import {
  checkMatchMedia,
  removeEmptyValueObject,
  flattenObject,
} from '../../utils/helpers';
import handleError from '../../utils/handleError';
import useQuery from '../../utils/hook/useQuery';

// Type
import { Props, SelectorProps, PayloadUpdate, PayloadCreate } from './interfaces';
import RenderFilter, { Filter } from '../../utils/listDaynamicFilterHookForm';
import Can from '../../components/Can';
import EXCEL from './excel';
import SKUExcel from './components/excel';
import { Link } from 'react-router-dom';
import { makeSelectPartnerCategoriesList } from '../partners/selectors';
import {
  GetSkuInventoryFlowRequestBuilder,
} from 'client-sdk/src/skus/skus';
import Client from 'client-sdk/src/client';
import Bell from '../../components/Notification/Bell';
import VideoModal from '../../components/Modal/video';
import downloadVideo from 'client-sdk/src/video/download'
import TicketLink from '../../components/ticketLink';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& #showFilter .MuiInput-underline::before, & #showFilter .MuiInput-underline::after':
      {
        borderBottom: '2px solid #DFA01F !important',
      },
    },
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      padding: '10px 0',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cards: {
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      backgroundColor: 'white',
      padding: '14px',
      width: '100%',
      height: '148px',
    },
    iconHeader: {
      // position: 'relative',
      marginTop: '-22px',
      marginRight: '-22px',
    },
    cardContent: {
      marginTop: '-22px',
      display: 'flex',
    },
    hover: {
      '&:hover': {
        curser: 'pointer',
      },
    },
    chart: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    progress: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },

    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    title: {
      fontWeight: 500,
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
    link: {
      textDecoration: 'none',
    },
    btnBox: {
      marginTop: '5px',
      padding: '10px',
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      '@media (max-width: 768px)': {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      },
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    cardContentOrder: {
      padding: '0',
    },
    cardContentlist: {
      justifyContent: 'space-between',
      padding: ' 0',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    tabs: {
      zIndex: '12',
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.08)',
      position: 'fixed',
      top: '52px',
      right: '0',
      borderBottom: '1',
      borderColor: '#000',
      width: '100%',
      backgroundColor: '#fff',
    },
    card: {
      width: '100%',
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px 0 0',
      paddingBottom: '0',
    },
  })
);

// Const
interface ObjectString {
  edit: string;
  detail: string;
  assign: string;
  inventory: string;
}

const translate: ObjectString = {
  edit: 'ویرایش',
  detail: 'جزیيات محصول',
  assign: 'لیست محصول',
  inventory: 'گزارش موجودی محصول',
};

type ModalType = "REPORT" | "CONFIRM_DISABLE" | "OPEN_DIALOG" | "VIDEO" | ""

const vitrin = localStorage.getItem('vitrin') || null
const Products: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openSizeReport, setOpenSizeReport] = React.useState(false as boolean);
  const [filters, setFilters] = useState([] as Filter[]);
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
  } as any);
  const [type, setType] = useState('edit' as string);

  const [id, setId] = useState(-1 as number);
  const [modal, setModal] = useState<ModalType>("")
  const [video, setVideo] = useState<string>()
  const [reportLoading, setReportLoading] = useState(false as boolean);
  const [reportList, setReportList] = useState<any>(null);
  const [excelReportList, setExcelReportList] = useState<any>(null);
  const [reportFilters, setReportFilters] = useState<any>({
    page: 0,
    size: 10,
  });
  const [videoLoading, setVideoLoading] = useState(false)
  const [reportId, setReportId] = useState(null as any);
  const [reportCsvLoading, setReportCsvLoading] = useState(false);
  const [inventoryFilters, setInventoryFilters] = useState({
    page: 0,
    size: 10,
  } as any);
  const [isMob, setIsMob] = useState(false);
  const [value, setValue] = useState(0);
  const { width } = windowSize();

  const token = localStorage.getItem('token') || '';

  const handleCloseSelect = () => {
    setOpenSize(false);
  };
  const handleCloseReportModal = () => {
    setModal("");
    setFiltersValues({
      page: 0,
      size: 10,
    });
    setReportList(null);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };
  const handleChangeSizeReportList = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setReportFilters({ ...reportFilters, page: 0, size: event.target.value });
    fetchReportList(reportId, { ...reportFilters, size: event.target.value });
  };

  // useEffect(() => {
  //   fetchVideo()
  // }, [])

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  useEffect(() => {
    getProducts();
    getAllProductsList();
    getCategories();
    setupFilters();
  }, [filtersValues]);

  useEffect(() => {
    setupFilters();
  }, [props.categoryLoading]);

  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const fetchVideo = async () => {
    try {
      setVideoLoading(true)
      const response = await downloadVideo("SINGLE_PRODUCT")
      const reader = response?.body?.getReader();
      let buffer = [];
      while (1) {
        const { value, done } = await reader?.read();
        if (done) {
          const blob = new Blob(buffer);
          const blobUrl = URL.createObjectURL(blob);
          setVideo(blobUrl)
          break;
        }
        buffer.push(value);
      }
      setVideoLoading(false)
    } catch (err) {
      setVideoLoading(false)
      handleError(err.response)
    }
  }

  const onVideoOpen = () => {
    setModal("VIDEO")
    fetchVideo()
  }

  const getProducts = () => {
    const { page, size } = filtersValues;
    const { partnerId } = props.match.params;
    props.productsDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: { equals: partnerId },
      page,
      size,
    });
  };
  const getVitrinProducts = () => {
    const { page, size } = filtersValues;
    const { partnerId } = props.match.params;
    props.vitrinProductsDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: { equals: partnerId },
      page,
      size,
    });
  };

  const getAllProductsList = () => {
    const { page } = filtersValues;
    const { partnerId } = props.match.params;
    props.allProductsDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: { equals: partnerId },
      page,
      size: 10000,
    });
  };

  const getCategories = () => {
    const { page, size } = filtersValues;
    const { partnerId } = props.match.params;
    props.categoriesDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: { equals: partnerId },
      page,
      size,
    });
  };

  const fetchReportExcel = async (args: Record<string, any>) => {
    try {
      setReportLoading(true);
      const request = new GetSkuInventoryFlowRequestBuilder()
        .id(reportId)
        .params({
          ...removeEmptyValueObject(flattenObject(args)),
        })
        .build();

      const client = new Client(token);
      const { data } = await client.execute(request);
      setExcelReportList(data);
    } catch (err) {
      handleError(err.response);
    } finally {
      setReportLoading(false);
    }

  }

  const fetchReportList = async (id: number, args: Record<string, any>) => {
    try {
      setReportLoading(true);
      const request = new GetSkuInventoryFlowRequestBuilder()
        .id(id)
        .params({
          ...removeEmptyValueObject(flattenObject(reportFilters)),
          ...args,
        })
        .build();

      const client = new Client(token);
      const { data } = await client.execute(request);
      setReportList(data);
    } catch (err) {
      handleError(err.response);
    } finally {
      setReportLoading(false);
    }
  };

  const findSelectedItem = (id: number) => {
    const findSelectSku = props.skusInventoryList?.find(
      (el: any) => el.id === id
    )!;
  };

  const handleReport = (id: number) => {
    setModal("REPORT");
    setId(id);
    setReportId(id);
    fetchReportList(id);
    // props.getParcelsDispatch({'skuId.equals': id, size: 150});
    findSelectedItem(id);
  };


  const handleChangeReportPage = (
    _: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setReportFilters({ ...reportFilters, page: page - 1 });
    fetchReportList(reportId, { ...reportFilters, page: page - 1 });
  };

  const handleGetParcelInventory = (id: number) => {
    setInventoryFilters((prevState: Record<string, any>) => ({
      ...prevState,
      'parcelId.equals': id,
    }));
    getParcelInventoryRequest({ 'parcelId.equals': id });
  };

  const getParcelInventoryRequest = (arg: Record<string, any>) => {
    props.getParcelInventoryItems({ ...inventoryFilters, ...arg });
  };

  const setupFilters = () => {
    Can({
      role: authContext.user.role,
      perform: 'orders:filtersByCenterId',
      yes: () => {
        setFilters([
          {
            type: 'input',
            id: 'name.contains',
            label: 'نام کالا',
            icon: mdiArchiveOutline,
          },
          {
            type: 'checkbox',
            id: 'categoryName.contains',
            label: 'دسته بندی',
            icon: mdiFormatListBulleted,
            data: props.categoriesList.map(category => category.name),
            translateType: 'Category',
          },
          {
            type: 'input',
            id: 'code.contains',
            label: 'کد کالا',
            icon: mdiKeyOutline,
          },
          {
            type: 'number',
            id: 'sellerId.equals',
            label: 'شناسه فروشنده',
            icon: mdiKeyOutline,
          },
          {
            type: 'number',
            id: 'providerId.equals',
            label: 'شناسه تامین کننده',
            icon: mdiKeyOutline,
          },
          {
            type: 'input',
            id: 'sellerCode.equals',
            label: 'کد فروشنده',
            icon: mdiKeyOutline,
          },
          {
            type: 'input',
            id: 'providerCode.equals',
            label: 'کد تامین کننده',
            icon: mdiKeyOutline,
          },
          {
            type: 'number',
            id: 'id.equals',
            label: 'شناسه کالا',
            icon: mdiKeyOutline,
          },
        ]);
      },
      no: () => {
        setFilters([
          {
            type: 'input',
            id: 'name.contains',
            label: 'نام کالا',
            icon: mdiArchiveOutline,
          },
          {
            type: 'checkbox',
            id: 'productCategory.in',
            label: 'دسته بندی',
            icon: mdiFormatListBulleted,
            data: props.categoriesList.map(category => category.name),
            translateType: 'Category',
          },
          {
            type: 'input',
            id: 'code.contains',
            label: 'شناسه کالا',
            icon: mdiKeyOutline,
          },
          {
            type: 'number',
            id: 'id.equals',
            label: 'شناسه کالا',
            icon: mdiKeyOutline,
          },
          {
            type: 'number',
            id: 'sellerId.equals',
            label: 'شناسه فروشنده',
            icon: mdiKeyOutline,
          },
          {
            type: 'number',
            id: 'providerId.equals',
            label: 'شناسه تامین کننده',
            icon: mdiKeyOutline,
          },
          {
            type: 'input',
            id: 'sellerCode.equals',
            label: 'کد فروشنده',
            icon: mdiKeyOutline,
          },
          {
            type: 'input',
            id: 'providerCode.equals',
            label: 'کد تامین کننده',
            icon: mdiKeyOutline,
          },
        ]);
      },
    });
  };

  const handleDisableUser = async () => {
    const body = props.productsList.find(item => item.id === id) as any;
    await props.updateProductsDispatch({
      body: { ...body, status: 'SUSPENDED' },
      pagination: filtersValues,
      id: props.match.params.partnerId,
    });
    setModal("")
  };

  const handleOpenConfirmDisable = (id: number) => {
    setModal("CONFIRM_DISABLE")
    setId(id);
  };
  const handleOpen = (id: number, type: string) => {
    setType(type);
    setModal("OPEN_DIALOG")
    setId(id);
  };

  const handleClose = () => {
    setModal("")
  };

  const handleOpenConfirmUpdateState = (data: { id: number; body: any }) => {
    setId(data.id);
  };

  return (
    <div className={classes.root}>
      {/* <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            padding: '5px 2px',
            width: '100%',
            borderRadius: '0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div className={classes.headerBox}>
            <Button
              variant='outlined'
              color='secondary'
              style={{ marginRight: "15px" }}
              onClick={onVideoOpen}
              disabled={videoLoading}
            >
              ویدئو آموزشی
            </Button>
          </div>
          <div
            style={{
              marginLeft: '140px',
              display: 'flex'
            }}
          >
            <RenderFilter
              filters={filters}
              onFilter={(filtervalues: any) => {
                setFiltersValues({
                  ...removeEmptyValueObject(filtervalues),
                  page: 0,
                  size: 10,
                });
              }}
              mainFiltersCount={0}
              baseFilter={{
                type: 'input',
                id: 'name.contains',
                placeholder: 'نام کالا',
              }}
              filterValues={filtersValues}
            />
            <TicketLink />
          </div>
        </Paper>
      </Grid> */}
      <Typography variant="h6" component="h2">
              {'مدیریت کالاها '}
            </Typography>
      <Grid container spacing={4} alignItems="center">
        <Grid
          container
          spacing={2}
          md={12}
          style={{
            // justifyContent: 'space-between',
            maxWidth: '120%',
            margin: '16px 1px',
          }}
        >

        </Grid>
        <Grid container item spacing={1}>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Grid>
                  <Typography className={classes.typographyCards}>
                    لیست کالاها
                  </Typography>
                </Grid>
              }
              action={
                <div className={classes.btnBox}>
                  <Can
                    role={authContext.user.role}
                    perform="/create-product"
                    yes={() => (
                      <>
                        <Link to="/create-product" className={classes.link}>
                          <Button
                            variant="outlined"
                            color="primary"
                            size={
                              checkMatchMedia('(max-width: 1024px)')
                                ? 'small'
                                : 'large'
                            }
                            startIcon={
                              <Icon path={mdiPlusBoxOutline} size={1} />
                            }
                          >
                            ایجاد کالا
                          </Button>
                        </Link>
                      </>
                    )}
                  />
                  <Can
                    role={authContext.user.role}
                    perform="product:grouping-create"
                    yes={() => (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ marginLeft: '5px' }}
                          onClick={() =>
                            props.history.push('/create-grouping-product')
                          }
                          startIcon={<Icon path={mdiPlusBoxOutline} size={1} />}
                          size={
                            checkMatchMedia('(max-width: 1024px)')
                              ? 'medium'
                              : 'medium'
                          }
                        >{`ایجاد گروهی کالا`}</Button>
                      </>
                    )}
                  />
                  {/* <Can
                    role={authContext.user.role}
                    perform="product:grouping-create"
                    yes={() => (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ marginLeft: '5px' }}
                          onClick={() =>
                            props.history.push('/update-grouping-product')
                          }
                          startIcon={<Icon path={mdiPlusBoxOutline} size={1} />}
                          size={
                            checkMatchMedia('(max-width: 1024px)')
                              ? 'medium'
                              : 'medium'
                          }
                        >{`ویرایش گروهی کالا`}</Button>
                      </>
                    )}
                  /> */}
                  <Can
                    role={authContext.user.role}
                    perform="parcels:downloadReportCSV"
                    yes={() => (
                      <>
                        <EXCEL
                          parcelsDispatch={props.allProductsDispatch}
                          data={props.allProductsList}
                          filtersValues={filtersValues}
                          loading={props.allProductsListLoading}
                        />
                      </>
                    )}
                  />
                </div>
              }
            />

            <CardContent className={classes.cardContentOrder}>
              <Grid
                container
                lg={12}
                md={12}
                className={classes.cardContentlist}
              >
                <Grid container item lg={12} md={12}>
                  <Grid
                    container
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    alignItems="center"
                  >
                    {props.loading ? (
                      <div className={classes.loading}>
                        <CircularProgress />
                      </div>
                    ) : (
                      props.productsList && (
                        <List
                          handleReport={handleReport}
                          data={props.productsList}
                          handleOpenConfirmDisable={handleOpenConfirmDisable}
                          handleOpen={handleOpen}
                          changeStatus={handleOpenConfirmUpdateState}
                        />
                      )
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{ padding: '20px 10px 0 10px' }}
                  >
                    {props.productsList && (
                      <FormControl
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                          {' '}
                          تعداد نمایش در هر صفحه:
                        </div>
                        <Select
                          open={openSize}
                          onClose={handleCloseSelect}
                          className={classes.showCount}
                          onOpen={() => setOpenSize(true)}
                          value={filtersValues.size}
                          onChange={handleChangeSizePage}
                        >
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={20}>20</MenuItem>
                          <MenuItem value={50}>50</MenuItem>
                          <MenuItem value={100}>100</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  </Grid>
                  <Grid
                    xs={12}
                    sm={6}
                    container
                    item
                    direction="row-reverse"
                    style={{ padding: '20px 10px 0 10px' }}
                  >
                    {props.productsList && value == 0 && (
                      <Pagination
                        count={Math.ceil(props.count / filtersValues.size)}
                        color="secondary"
                        page={filtersValues.page + 1}
                        onChange={handleChangePage}
                      />
                    )}
                    {props.vitrinProductsList && value == 1 && (
                      <Pagination
                        count={Math.ceil(props.vitrinProductsCount / filtersValues.size)}
                        color="secondary"
                        page={filtersValues.page + 1}
                        onChange={handleChangePage}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Dialog
        fullWidth
        open={modal == "CONFIRM_DISABLE"}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          {` آیا از غیر فعال کردن محصول با نام
          "${props.productsList.find(item => item.id === id)?.name}"
          اطمینان دارید؟`}
        </DialogTitle>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleClose}
            variant="contained"
            color="primary"
          >
            {'خیر'}
          </Button>
          <Button
            onClick={handleDisableUser}
            variant="outlined"
            color="primary"
          >
            {'بله'}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen
        open={modal == "OPEN_DIALOG"}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>{` 
          ${translate[type]}
        "${props.productsList.find(item => item.id === id)?.name}"
        `}</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {'بازگشت'}
          </Button>
        </DialogTitle>
        <DialogContent>
          {type === 'edit' && (
            <Edit
              data={props.productsList.find(item => item.id === id)}
              partnerId={props.match.params.partnerId}
              update={body => {
                props.updateProductsDispatch({
                  body,
                  pagination: filtersValues,
                  id: props.match.params.partnerId,
                });
                handleClose();
              }}
            />
          )}

          {type === 'inventory' && (
            <Inventory
              data={props.productsList.find(product => product.id === id)}
            />
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        fullScreen
        open={modal == "ADD"}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>ایجاد محصول جدید</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {'بازگشت'}
          </Button>
        </DialogTitle>
        <DialogContent>
          <Add
            partnerId={props.match.params.partnerId}
            create={body => {
              props.createProductDispatch({
                body,
                pagination: filtersValues,
                id: props.match.params.partnerId,
              });
              handleClose();
            }}
          />
        </DialogContent>
      </Dialog>
      <Modal
        maxWidth="md"
        onClose={handleCloseReportModal}
        open={modal == "REPORT"}
        title={
          <div style={{ textAlign: 'right' }}>
            <span>{`تاریخچه ورود و خروج کالای ${props.productsList.find(item => item.id === id)?.name
              }`}</span>
          </div>
        }
        content={
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {reportLoading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <React.Fragment>
                  <Grid item xs={12}>
                    <div style={{ textAlign: 'left' }}>
                      <Can
                        role={authContext.user.role}
                        perform="skus:downloadCSV"
                        yes={() => (
                          <SKUExcel
                            loading={reportCsvLoading}
                            CreateExcel={fetchReportExcel}
                            data={excelReportList?.content}
                          />
                        )}
                      />
                    </div>
                    <Box mb={3} />
                  </Grid>
                  <ReportList
                    data={reportList?.content}
                    handleSelect={handleGetParcelInventory}
                  />
                </React.Fragment>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSizeReport}
                  onClose={() => setOpenSizeReport(false)}
                  onOpen={() => setOpenSizeReport(true)}
                  value={reportFilters.size}
                  onChange={handleChangeSizeReportList}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} sm={6} container item direction="row-reverse">
              <Pagination
                className={classes.pagination}
                count={Math.ceil(
                  reportList?.totalElements / reportFilters.size
                )}
                color="secondary"
                page={reportFilters?.page + 1}
                onChange={handleChangeReportPage}
              />
            </Grid>
          </Grid>
        }
      />
      <VideoModal src={video} onClose={() => setModal("")} open={modal === "VIDEO"} loading={videoLoading} />
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  skusInventoryList: makeSelectSkusInventoryList(),
  productsList: makeSelectList(),
  vitrinProductsList: makeSelectVitrinList(),
  vitrinProductsCount: makeSelectVitrinCount(),
  categoriesList: makeSelectPartnerCategoriesList(),
  allProductsList: makeSelectAllList(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  allProductsListLoading: makeSelectAllListLoading(),
  categoryLoading: makeCategoriesLoding(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getSkusInventoryDispatch: (payload: any) =>
      dispatch(getSkusInventoryActions(payload)),
    productsDispatch: (payload: Record<string, any>) =>
      dispatch(getProductsAction(payload)),
    vitrinProductsDispatch: (payload: Record<string, any>) =>
      dispatch(getVitrinProductsAction(payload)),
    categoriesDispatch: (payload: Record<string, any>) =>
      dispatch(getPartnerCategoriesActions(payload)),
    allProductsDispatch: (payload: Record<string, any>) =>
      dispatch(getAllProductsAction(payload)),
    updateProductsDispatch: (payload: PayloadUpdate) =>
      dispatch(updateProductActions(payload)),
    createProductDispatch: (payload: PayloadCreate) =>
      dispatch(createProductsActions(payload)),
    getParcelInventoryItems: (payload: any) =>
      dispatch(getParcelInventoryItemsAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Products);
